import React from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FaSlack } from "react-icons/fa";
import { FcGoogle } from "react-icons/fc";
import Cookies from 'js-cookie';

export default function Auth() {
  const handleSlackLogin = async () => {
    try {
      const token = Cookies.get("token");

      const config = {
        headers: {}
      };

      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/auth/slack`,
        config
      );

      const data = response.data;
      if (data.url) {
        window.location.href = data.url;
      } else {
        throw new Error("No redirect URL received");
      }
    } catch (error) {
      console.error("Slack login failed:", error.message);
      alert(error.message || "Slack login failed.");
    }
  };

  return (
    <section className="vh-100 bg-dark">
      <div className="container py-5 h-100">
        <div className="row d-flex align-items-center justify-content-center h-100">
          <div className="col-md-8 col-lg-7 col-xl-6">
            <img
              src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-login-form/draw2.svg"
              className="img-fluid"
              alt="Phone"
            />
          </div>
          <div className="col-md-7 col-lg-5 col-xl-5 offset-xl-1 d-flex justify-content-center">
            <form className="d-flex flex-column align-items-center gap-4">
              <a
                className="btn btn-primary d-flex align-items-center gap-3 px-4 py-3"
                style={{
                  backgroundColor: '#4A154B',
                  border: '1px solid #DADCE0',
                  width: '350px',
                  justifyContent: 'flex-start',
                }}
                href="#!"
                role="button"
                onClick={handleSlackLogin}
              >
                <FaSlack className="fs-4" />
                <span className="fs-5">Continue with Slack</span>
              </a>

              <a
                className="btn btn-primary d-flex align-items-center gap-3 px-4 py-3"
                style={{
                  backgroundColor: '#1F1F1F',
                  border: '1px solid #DADCE0',
                  width: '350px',
                  justifyContent: 'flex-start',
                }}
                href="#!"
                role="button"
              >
                <FcGoogle className="fs-4" />
                <span className="fs-5">Continue with Google</span>
              </a>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
